<button type="button" class="back-btn">
    <span class="material-symbols-rounded arrow-left">
        arrow_left_alt
    </span>
    <!-- &#xEF7D; -->
    <!-- <mat-icon aria-hidden="false" aria-label="Back" fontIcon="arrow_left_alt"></mat-icon> -->
</button>
